// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"384":"ed86b127","387":"cf546d89","492":"d2e2019d"}[chunkId] + ".css";
};